var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#EE3858"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.64 10.921H8.093L7.768 4.72h2.196l-.323 6.201zm-1.897 2.171c0-.355.095-.624.285-.806.19-.182.468-.273.832-.273.351 0 .622.093.812.28.195.186.292.452.292.8 0 .334-.097.598-.292.793-.194.19-.465.285-.812.285-.356 0-.63-.093-.825-.279-.195-.19-.292-.457-.292-.8z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "./fonts/warning.6c772625630d5dd4d5224dc67cceecff.svg";
export { SvgWarning as ReactComponent };